import React from 'react';

import InternalLink from 'notebook/mediocre/mentions/InternalLink';
import {TypedValue} from 'notebook/tables/TableConstants';
import withSelectorLoading from 'registry/schema-field-selector/withSelectorLoading';
import {SchemaFieldSelector, SchemaFieldSelectorOption} from 'schemas/SchemaFieldSelectorConstants';
import {areAllOptionsValid, getSelectorOptions} from 'schemas/tags/SchemaFieldSelectorUtil';

interface SelectorTagValueViewerProps {
  typedValue: TypedValue;
  textValue: string;
  registryId?: string;
  schemaFieldSelectorId?: string | null;
  schemaFieldSelector: SchemaFieldSelector | null;
}

export function SelectorInternalLink({name}: {name: string}): JSX.Element {
  return (
    <span>
      <InternalLink className="chip-container chip--tableCell" internalLink={{name}} />
    </span>
  );
}

/**
 * Viewer for selector tag values.
 */
// eslint-disable-next-line react/prefer-stateless-function
class SelectorTagValueViewer extends React.Component<SelectorTagValueViewerProps> {
  render(): JSX.Element | null {
    if (this.props.typedValue.type !== 'ft_selector') {
      // This could be a COMPUTED value or some other typed value that was copied in.  In those cases, just
      // show the "textValue" here.
      return <span>{this.props.textValue}</span>;
    }
    const schemaFieldSelectorTypedValue = this.props.typedValue;
    const schemaFieldSelectorOptionIds = schemaFieldSelectorTypedValue.schemaFieldSelectorOptionIds;
    if (
      !this.props.schemaFieldSelector ||
      schemaFieldSelectorOptionIds == null ||
      !areAllOptionsValid(schemaFieldSelectorOptionIds, this.props.schemaFieldSelector)
    ) {
      // Some of the option ids are not found in the selector or there is no selector loaded yet. This may be
      // caused by pasting a value from a different column.  In any case, render using the value from the
      // typed value
      return <span>{schemaFieldSelectorTypedValue.value}</span>;
    }
    const selectedOptions = getSelectorOptions(schemaFieldSelectorOptionIds, this.props.schemaFieldSelector);
    return (
      <span>
        {selectedOptions.map(({name}: SchemaFieldSelectorOption, i: number) => (
          <SelectorInternalLink name={name} key={i} />
        ))}
      </span>
    );
  }
}

export default withSelectorLoading(
  SelectorTagValueViewer,
  (props: SelectorTagValueViewerProps): string | null => props.schemaFieldSelectorId ?? null
);
